module.exports = {
  translation: {
    about: 'About',
    artist: 'Artist',
    artists: 'Artists',
    chatUsernameExists: 'That username already exists, please choose another one.',
    city: 'City',
    cities: 'Cities',
    countries: 'Countries',
    country: 'Country',
    freqAsia: 'Frequency Asia',
    home: 'Home',
    lessInfo: 'Less Info',
    moreInfo: 'More Info',
    nowPlaying: 'Now Playing',
    numEpisodes: '{{ count }} Episode',
    numEpisodes_plural: '{{ count }} Episodes',
    offline: 'Offline',
    ourPicks: 'Our Picks',
    pageNotFound: 'Page Not Found',
    projects: 'Projects',
    recentEpisodes: 'Recent Episodes',
    schedule: 'Schedule',
    seeAllEpisodes: 'SEE ALL EPISODES',
    shows: 'Shows',
    wiki: 'Wiki',
  },
};
